import richText from "utilities/richText"
import CallToAction from "components/CallToAction"
import { getStoryblokLink } from "utilities/getStoryblokLink"
import cn from "classnames"

export default function FourColumnSection({ blok }) {
  const columnStyles = cn("prose-headings:text-primary prose-headings:pb-2", {
    "prose-h3:text-white text-white": blok.background_color === "primary",
  })

  return (
    <section className={`px-5 bg-${blok.background_color}`}>
      <div className="mx-auto max-w-screen-xl py-12 lg:py-16">
        <h2
          className={cn("text-center", {
            "text-primary": blok.background_color === "white",
            "text-white": blok.background_color === "primary",
          })}
        >
          {blok.heading}
        </h2>
        <div className="grid lg:grid-cols-4 gap-6 lg:gap-8 py-8 lg:py-12">
          <div className={columnStyles}>{richText(blok.column_1_content)}</div>
          <div className={columnStyles}>{richText(blok.column_2_content)}</div>
          <div className={columnStyles}>{richText(blok.column_3_content)}</div>
          <div className={columnStyles}>{richText(blok.column_4_content)}</div>
        </div>
        <div className="flex justify-center">
          {blok.cta_label ? (
            <CallToAction href={getStoryblokLink(blok.cta_link)} style="primary">
              {blok.cta_label}
            </CallToAction>
          ) : null}
        </div>
      </div>
    </section>
  )
}
